import gql from "graphql-tag";

export const enum ProspectStage {
    NOT_INTERESTED = "NOT_INTERESTED",
    NONE_OF_THE_ABOVE = "NONE_OF_THE_ABOVE",
    GATHERING_INFO = "GATHERING_INFO",
    COMPARING = "COMPARING",
    NARROWED = "NARROWED",
    PREPARING = "PREPARING",
    APPLIED = "APPLIED",
    ADMITTED = "ADMITTED",
}

export const enum ProspectStageLocation {
    WIDGET_CHAT = "WIDGET_CHAT",
    WIDGET_SIGNUP = "WIDGET_SIGNUP",
    WIDGET_DECISION_PAGE = "WIDGET_DECISION_PAGE",
    WIDGET_NOT_INTERESTED_PAGE = "WIDGET_NOT_INTERESTED_PAGE",
}

export type ProspectStageOption = {
    name: string;
    translationKey: string;
    value: ProspectStage;
};

const OptOutStages = new Set([ProspectStage.NOT_INTERESTED, ProspectStage.NONE_OF_THE_ABOVE]);

const AppliedStages = new Set([ProspectStage.APPLIED, ProspectStage.ADMITTED]);

export function isProspectAppliedStage(stage: ProspectStage): boolean {
    return AppliedStages.has(stage);
}

export const DecisionStagePageTitle = {
    translationKey: "decisionStagePageTitle",
    name: "Decision Stage",
};

export const DecisionStagePageSubtitle = {
    translationKey: "decisionStagePageSubtitle",
    name: "Update your decision stage for personalised recommendations",
};

export const enum DecisionStageLayout {
    STACK = "STACK",
    TILE = "TILE",
}

export const PROSPECT_STAGES: Readonly<ProspectStageOption[]> = Object.freeze([
    {
        name: "None of the above",
        translationKey: "noneOfTheAbove",
        value: ProspectStage.NONE_OF_THE_ABOVE,
    },
    {
        name: "Started gathering information",
        translationKey: "gatheringInformation",
        value: ProspectStage.GATHERING_INFO,
    },
    {
        name: "Comparing institutions",
        translationKey: "comparingOptions",
        value: ProspectStage.COMPARING,
    },
    {
        name: "Narrowing down options",
        translationKey: "narrowedDown",
        value: ProspectStage.NARROWED,
    },
    {
        name: "Preparing applications",
        translationKey: "preparing",
        value: ProspectStage.PREPARING,
    },
    {
        name: "Waiting for offers",
        translationKey: "submitted",
        value: ProspectStage.APPLIED,
    },
    {
        name: "Choosing between offers",
        translationKey: "admitted",
        value: ProspectStage.ADMITTED,
    },
]);

export const ProspectStageNoneOfTheAbove: ProspectStageOption = PROSPECT_STAGES[0];

export const ProspectStagesForUi: Readonly<ProspectStageOption[]> = PROSPECT_STAGES.filter(
    (s) => !OptOutStages.has(s.value),
);

export const prospectStageMutation = gql`
    mutation ProspectStageMutation(
        $universityId: ObjectId!
        $decisionStage: DecisionStageEnum!
        $prospectStageLocation: DecisionStageLocationEnum!
    ) {
        saveUserDecisionStage(
            decisionStageInput: {
                universityId: $universityId
                decisionStage: $decisionStage
                decisionStageLocation: $prospectStageLocation
            }
        ) {
            userId
        }
    }
`;
